import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import Tns from './Pages/Tns';
import { AuthProvider } from './Pages/auth';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

msalInstance.initialize()
  .then(() => {
    return msalInstance.handleRedirectPromise();
  })
  .then(async (response) => {
    let preloadedUser = null;

    if (response?.account) {
      console.log('[SSO] Azure redirect received | username:', response.account.username, '| name:', response.account.name);
      try {
        const res = await fetch(`${API_BASE}/auth/sso-login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: response.account.username }),
        });
        console.log('[SSO] backend /auth/sso-login response status:', res.status);
        if (res.ok) {
          const data = await res.json();
          console.log('[SSO] login SUCCESS | sal_code:', data.user?.sal_code, '| role_code:', data.user?.role_code);
          sessionStorage.setItem('token', data.token);
          sessionStorage.setItem('user', JSON.stringify(data.user));
          preloadedUser = data.user;
          window.history.replaceState({}, document.title, '/');
        } else {
          const err = await res.json().catch(() => ({}));
          console.error('[SSO] login FAILED | status:', res.status, '| message:', err.message, '| email sent:', response.account.username);
        }
      } catch (err) {
        console.error('[SSO] fetch error:', err);
      }
    } else {
      console.log('[SSO] handleRedirectPromise: no account in response (normal page load, not a redirect callback)');
    }

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <AuthProvider>
            <Tns />
          </AuthProvider>
        </BrowserRouter>
      </MsalProvider>
    );
  })
  .catch((err) => {
    console.error('[SSO] initialize/redirect error:', err);
  });

reportWebVitals();
